import { useEffect, useRef, useState } from "react";

const COUNTDOWN_SECONDS = 300; // 5 minutes

const BookingCountdown = ({ resetAfterTimeOutOrError }) => {

    const [timeLeft, setTimeLeft] = useState(COUNTDOWN_SECONDS);

    // Fixed the moment this component mounts, and never recomputed. This is the fix (#217):
    // every later check measures wall-clock time against this one deadline, instead of
    // decrementing a counter once per tick. setInterval is throttled in a backgrounded tab --
    // while a customer is off in the PayPal popup, ticks can arrive minutes apart instead of
    // every second, and a tick-counter silently under-counts real elapsed time when that
    // happens. Comparing against a fixed deadline cannot: a late tick just sees a bigger gap
    // to the deadline, never a smaller decrement.
    const deadlineRef = useRef(Date.now() + COUNTDOWN_SECONDS * 1000);

    // Always calls the *current* resetAfterTimeOutOrError without needing it in the effect's
    // dependency array below, so the interval itself keeps running across re-renders instead
    // of being torn down and recreated on every one.
    const resetRef = useRef(resetAfterTimeOutOrError);
    useEffect(() => {
        resetRef.current = resetAfterTimeOutOrError;
    }, [resetAfterTimeOutOrError]);

    useEffect(() => {
        const tick = () => {
            const remainingMs = deadlineRef.current - Date.now();
            setTimeLeft(Math.max(0, Math.ceil(remainingMs / 1000)));

            if (remainingMs <= 0) {
                clearInterval(timer);
                resetRef.current();
            }
        };

        const timer = setInterval(tick, 1000);
        return () => clearInterval(timer);
    }, []); // the deadline is fixed at mount; this must run exactly once


    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    };


    return (
        <div className="booking-countdown">
            Time left to complete your booking: {formatTime(timeLeft)}
        </div>
    );
};

export default BookingCountdown;
